function TextInput(props) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-gray-600 font-medium">{props.label}</label>
      <input
        type={props.type || "text"}
        placeholder={props.placeholder}
        className={
          props.className ||
          "w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400  focus:border-transparent transition-all placeholder-gray-400"
        }
      />
    </div>
  );
}

export default TextInput;
